import { User } from '../models/user';

export const getSenderTitle = (currentUser: User | undefined) => {
  let returnValue = '';

  if (currentUser) {
    // Om det bara finns ett distrikt eller en lokalförening tas namnet från det
    if (currentUser.districts.length === 1) {
      returnValue += currentUser.districts[0].countyAss;
    } else if (currentUser.associations.length === 1) {
      returnValue += currentUser.associations[0].localAss;
    } else {
      // Annars tar vi förbundets namn som avsändartitel
      returnValue = currentUser.customerName || '';
    }
  }
  return returnValue;
};
